import React, { CSSProperties, FC, useEffect, useMemo, useRef, useState } from "react";
import classNames from "classnames";
import { ChevronDown, Copy } from "kaleidoscope/src/global/icons";
import { ButtonTheme, IconButton, CopyToClipboard } from "kaleidoscope";
import { Language } from "prism-react-renderer";
import Code from "../../components/Code";

interface IPostCodeProps {
  className?: string;
  children: string;
}

const PostCode: FC<IPostCodeProps> = ({ className = "language-jsx", children }) => {
  const params = className.split("-");
  const language = params[1] as Language;
  const code = useMemo(() => children.slice(0, children.lastIndexOf("\n")), [children]);

  return (
    <div className="kld-post-code">
      <div className="kld-post-code__content">
        <div className="kld-post-code__actions">
          <CopyToClipboard value={children}>
            {({ onCopy }) => <IconButton icon={<Copy />} onClick={onCopy} theme={ButtonTheme.Dark} />}
          </CopyToClipboard>
        </div>
        <Code className="kld-post-code__element" code={code} language={language} />
      </div>
    </div>
  );
};

export default PostCode;
